module.exports = __webpack_public_path__ + "static/img/16优秘.b029abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/16优秘.jpg
// module id = GUnc
// module chunks = 0